import cn from 'classnames';
import { useFormikContext } from 'formik';
import { ChangeEvent, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import AdvertismentMap from '../../../../../../components/advertisementMap';
import DotsLoading from '../../../../../../components/dotsLoading';
import FormikLikeInput from '../../../../../../components/formikFileds/likeInput';
import FormikTextArea from '../../../../../../components/formikFileds/textArea';
import CustomCheckbox from '../../../../../../components/mazraeKit/customCheckbox';
import ToggleSwitch from '../../../../../../components/mazraeKit/toggleSwitch';
import { useAuth } from '../../../../../../context/authContext';
import FloatingOnlySelectBottomSheet from '../../../../../../module/newShop/advertisementRegisteration/floatingOnlySelectBottomSheet';
import { RootState } from '../../../../../../store/redux';
import {
  addFormData,
  isSendingData,
} from '../../../../../../store/redux/advertisementRegisteration';
import Num2persian from '../../../../../../utilities/helper/convertNumToPersian';
import { ScrollSection } from '../../../../../../utilities/helper/scrollToError/errorScroll.constants';
import { getPriceUnits } from '../../../../../../utilities/helper/unitGenerator';
import { AdvertisementType } from '../../../../../../utilities/helper/unitGenerator/unit.types';
import { FromikType } from '../../../types';
import { rentHandleDescriptionText } from '../../../utils';
import AdditionalInfo from '../../additionalInfo';
import AdvertisementUploadImage from '../../advertisementUploadImage';
import CommonField from '../../commonField';
import FarmAdditionalMainInfo from '../../sale/farmAdditionalMainInfo';

const ProvidedRentFarmForm = ({isLoading}: {isLoading?: boolean}) => {
  const {supplierProfile} = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const myRef = useRef<HTMLDivElement | null>(null);

  const [touched, setTouched] = useState<boolean>(false);

  const [location, setLocation] = useState<ILocation>({
    lat: Number(supplierProfile?.latlong?.[0]),
    lng: Number(supplierProfile?.latlong?.[1]),
  });

  const {input, sub_input, input_group, srs_type, rentBottomSheetData} =
    useSelector((state: RootState) => state.advertisementRegisteration);
  const {setFieldValue, values, errors} = useFormikContext<FromikType>();

  useEffect(() => {
    if (
      input_group &&
      sub_input &&
      input_group.type &&
      values?.wanted_number &&
      values?.requirement_during
    ) {
      setFieldValue(
        'title',
        rentHandleDescriptionText(
          values,
          sub_input?.title,
          values?.wanted_number,
        )[input_group.type],
      );
    }
  }, [
    values.wanted_number,
    values?.requirement_during,
    values?.request_date_unit,
  ]);

  useEffect(() => {
    setFieldValue('location', location);
  }, [location]);

  useEffect(() => {
    myRef.current?.scrollIntoView({behavior: 'smooth'});
  }, [myRef.current]);

  useEffect(() => {
    setFieldValue('title', sub_input?.title);
  }, [sub_input]);

  return (
    <div className="flex flex-col gap-3">
      {input?.code === 13 && (
        <section className="flex flex-col" id={ScrollSection.SUB_INPUT}>
          <div className="flex mb-2 text-gray-900 font-Medium" ref={myRef}>
            {/* <span className="text-md">
              نوع {input_group?.type && GroupNameToInputName[input_group?.type]}{' '}
              {input?.title} را وارد کنید.
            </span> */}
            <span className="text-md">نوع {input?.title} را وارد کنید.</span>
            <span className="color-red-3">*</span>
          </div>
          <div
            className={cn(
              'w-full h-12 rounded border-[1px] border-gray-700 px-2 flex items-center',
              {
                '|!border-red-550': touched && errors.sub_input?.title,
                '!border-farm-shop-500':
                  values.sub_input?.title && !errors.sub_input?.title,
              },
            )}
          >
            {!sub_input?.title && (
              <i className="mx-1 text-xl text-gray-700 icon-nameSearch" />
            )}
            <input
              className="w-full text-gray-700 text-md"
              name="sub_input"
              readOnly={true}
              value={sub_input?.title}
              placeholder="انتخاب نوع"
              onClick={() => {
                navigate('/advertisement-register-subInput-list', {
                  state: {
                    input: input?.guid,
                    backRoute: '/advertisement-registeration',
                  },
                });
              }}
            ></input>
          </div>
          <span className="pt-1 text-xs text-red-550">
            {touched && errors.sub_input?.title}
          </span>
        </section>
      )}
      {input?.code === 11 && (
        <FarmAdditionalMainInfo
          {...{input, input_group, sub_input, touched, srs_type}}
        />
      )}
      <section id={ScrollSection.TITLE}>
        <p className="mb-2 font-medium color-gray-1 text-md ">
          عنوان آگهی <span className="color-red-3">*</span>
        </p>
        <FormikLikeInput
          name="title"
          label=""
          placeholder="عنوان آگهی"
          touched={sub_input?.title ? true : touched}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            setFieldValue('title', e.target.value);
          }}
        />
        <span className="text-xs text-gray-900">حداکثر 45 حرف</span>
      </section>
      <section id={ScrollSection.DESCRIPTION}>
        <FormikTextArea
          name="description"
          touched={values.description ? true : touched}
          placeholder=""
          label="توضیحات"
          rows={5}
          labelClass="!text-md font-medium"
        />
        <span className="text-xs text-gray-900">
          میتوانید متن درخواست خود را ویرایش کنید.
        </span>
      </section>
      <AdvertisementUploadImage
        onClick={() => dispatch(addFormData(JSON.stringify(values)))}
      />
      <section id={ScrollSection.AD_PRICE}>
        <p className="mb-2 font-medium color-gray-1 text-md ">
          قیمت <span className="color-red-3 ">*</span>
        </p>
        <CommonField
          touched={touched}
          inputName="ad_price"
          bottomSheetName="price_unit"
          label="قیمت به تومان"
          secondaryTitle="تومان"
          commonBottomSheetData={getPriceUnits(
            rentBottomSheetData as AdvertisementType,
            input_group?.code as number,
            input?.code,
          )}
          disabled={values.price_on_call}
          type="number"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            if (e.target.value.length < 12) {
              setFieldValue('ad_price', e.target.value);
            }
          }}
        />
        {values.ad_price && (
          <span className="text-xs text-farm-shop-500">
            {values?.price_unit?.title}
            {Num2persian(values.ad_price?.toString())} تومان
          </span>
        )}
      </section>
      <section className="pr-1">
        <CustomCheckbox
          name="price_on_call"
          title="تماس بگیرید"
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            e.target.checked && setFieldValue('ad_price', '');
            setFieldValue('price_on_call', e.target.checked);
            setFieldValue('discount_amount', '');
          }}
          checked={values?.price_on_call}
        />
      </section>

      <section>
        <div className="flex items-center justify-between mt-8 mb-3">
          <span>تخفیف </span>
          <ToggleSwitch
            disabled={values?.price_on_call}
            isToggled={values?.price_on_call ? false : values?.has_discount}
            onToggle={(e: React.ChangeEvent<HTMLInputElement>) => {
              setFieldValue('has_discount', e.target.checked);
              setFieldValue('discount_amount', '');
            }}
          />
        </div>
        <span className="text-gray-600 text-md ">
          با اعمال تخفیف، آگهی در پیشنهادات شگفت انگیز نمایش داده می‌شود.
        </span>
      </section>
      <section id={ScrollSection.DISCOUNT}>
        <FormikLikeInput
          name="discount_amount"
          label=""
          secondaryTitle="درصد"
          disabled={!values.has_discount || values?.price_on_call}
          required={true}
          type="number"
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            if (Number(e.target.value) <= 100) {
              setFieldValue('discount_amount', e.target.value);
            }
          }}
        />
        {values.discount_amount && (
          <span className="text-xs text-farm-shop-500">
            {values.discount_amount} درصد تخفیف
          </span>
        )}
      </section>
      <section>
        <FloatingOnlySelectBottomSheet
          Placeholder="سایر مشخصات(اختیاری)"
          wrapperClass="border-gray-700"
          onClick={() => {
            navigate('/optional-registeration-info');
            dispatch(addFormData(JSON.stringify(values)));
          }}
        />
        <AdditionalInfo />
      </section>
      <section className="flex flex-col" id={ScrollSection.LOCATION}>
        <span className="text-md">محدوده آگهی</span>
        <div className="z-0 edit-ads-map">
          <AdvertismentMap
            center={location}
            selectLocation={location => {
              setLocation(location);
              setFieldValue('location', location);
            }}
          />
          <span className="pt-1 text-xs text-red-550">
            {errors?.location?.lat}
          </span>
        </div>
      </section>
      <section className="pr-1">
        <CustomCheckbox
          name="only_massage_buyer"
          title="فقط اجازه ارسال پیام به خریدار داده شود."
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setFieldValue('only_massage_buyer', e.target.checked)
          }
          checked={values?.only_massage_buyer}
        />
      </section>
      <button
        className={cn('w-full text-white  h-12 rounded mb-3', {
          'bg-farm-shop-200': isLoading,
          'bg-farm-shop-500': !isLoading,
        })}
        disabled={isLoading}
        type="submit"
        onClick={() => {
          dispatch(addFormData(JSON.stringify(values)));
          dispatch(isSendingData(true));
          setTouched(true);
        }}
      >
        {isLoading ? <DotsLoading /> : 'ثبت آگهی'}
      </button>
    </div>
  );
};

export default ProvidedRentFarmForm;
